import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  deliveryListParams,
  deliveryListSearchSchema,
  webhookDeliveriesQueryOptions,
  WebhookDetailPage,
  webhookEndpointQueryOptions,
} from '@/features/webhooks';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/webhooks/$endpointId')({
  staticData: { tours: ['settings.webhook-detail'] },
  // A function, not the schema itself: the schema's input would make every key required on the
  // endpoints table's links here, which pass no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    deliveryListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const deliveries = context.queryClient
      .query({
        ...webhookDeliveriesQueryOptions(
          params.storeId,
          params.endpointId,
          deliveryListParams(deps),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined);
    const endpoint = await context.queryClient.query({
      ...webhookEndpointQueryOptions(params.storeId, params.endpointId),
      staleTime: 'static',
    });
    // Filter, sort and page changes on the delivery log must not wait for the fetch, or a second
    // pick in the filter would build on the stale URL. The section shows the previous rows.
    if (cause !== 'stay') await deliveries;
    return { crumb: new URL(endpoint.url).host };
  },
  component: WebhookDetailPage,
});
